<template>
  <div class="box">
    <hearderCommon  :text="text"></hearderCommon>
    <div class="login">
      <!-- 文字 -->
      <div class="loginTitle">重置密码</div>
      <!-- 登录表单 -->
      <van-cell-group class="group">
        <van-field
          v-model="username"
          placeholder="请输入手机号"
          maxlength="11"
          @blur="reg"
          class="group_phon"
        />
        <van-field
          v-model="password"
          center
          clearable
          placeholder="验证码"
          @blur="word"
          class="group_word"
        >
          <van-button
            slot="button"
            size="small"
            class="login-button"
            @click="getCode"
            :text="btnTitle"
            :disabled="disabled1"
          ></van-button>
        </van-field>
        <button class="login-form-button" @click="login" :disabled="disabled">确认</button>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import hearderCommon from "../common/headerCommon";
export default {
  components: {
    hearderCommon
  },
  data() {
    return {
      username: "",
      text: "取消",
      password: "",
      patt: /^1[0-9]{10}$/,
      disabled: true,
      btnTitle: "获取验证码",
      disabled1: false,
      companyId: ""
    };
  },
  // 禁止按钮使用
  watch: {
    username(value) {
      if (this.patt.test(value)) {
        this.disabled = false;
      }
    }
  },
  created() {
    localStorage.removeItem("token");
    this.companyId = this.$route.query.companyId;
    if (this.companyId == undefined) {
      this.companyId = 1;
    }
  },
  methods: {
    // 校验验证码
    login() {
      if (this.password == "") {
        this.$toast("请输入验证码");
      } else {
        this.$axios
          .get(
            `/auth/smsAuth/checkCode?authType=2&code=${this.password}&mobile=${this.username}`
          )
          .then(res => {
            if (res.data.code == "0") {
              this.$router.push({
                path: "/resetlogin",
                query: {
                  companyId: this.companyId,
                  code: this.password,
                  mobile: this.username
                }
              });
            }
          });
      }
    },
    // 校验手机号
    reg() {
      if (!this.patt.test(this.username)) {
        this.$toast("请输入正确的手机号");
      }
    },
    // 校验验证码
    word() {
      if (this.password === "") {
        this.$toast("请输入验证码");
      }
    },
    getCode() {
      // 获取验证码
      if (this.patt.test(this.username)) {
        this.$axios
          .get(
            `/auth/smsAuth/code?action=reset&authType=2&companyId=${this.companyId}&mobile=${this.username}`
          )
          .then(res => {
            if (res.data.code == 0) {
              this.$toast("短信发送成功");
              //倒计时
              let time = 60;
              let timer = setInterval(() => {
                if (time == 0) {
                  clearInterval(timer);
                  this.disabled1 = false;
                  this.btnTitle = "获取验证码";
                } else {
                  this.btnTitle = time + "秒后重试";
                  this.disabled1 = true;
                  time--;
                }
              }, 1000);
            }
          });
      } else {
        this.$toast("请输入正确的手机号");
      }
    }
  }
};
</script>

<style scoped>
.box {
  padding-top: 1px;
  /* background: #fff; */
   background: url("../../assets/登录.png") center center repeat;
  height: 99%;
}
.login {
  width: 60%;
  height: 80%;
  margin: 15% auto 0;
}
.title {
  font-size: 25px;
  font-weight: 700;
  height: 10%;
  padding-left: 7%;
  color: rgba(51, 51, 51, 1);
}
.login-form-button {
  width: 89%;
  border: 0;
  border-radius: 50px;
  line-height: 30px;
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  color: #ffffff;
  margin-top: 20px;
  margin-bottom: 10px;
}
 
.protocol {
  color: rgba(116, 180, 43, 1);
  text-decoration: underline;
  font-size: 12px;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
.box >>> .header {
  background-color: transparent !important;
}
</style>